import React from 'react'
const HomeSlider = () => {
  return (
    <>
      <div className="slider-sec">
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld14.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld0.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld13.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld12.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld11.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld10.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld1.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld3.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld4.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld6.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld7.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld8.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>
            <div class="carousel-item"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sld9.jpg"
              class="d-block w-100" alt="Mata Mariam Jan Seva Vidyalay" /></div>

          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev"> <span className="carousel-control-prev-icon" aria-hidden="true"></span> <span className="visually-hidden">Previous</span> </button> <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next"> <span className="carousel-control-next-icon" aria-hidden="true"></span> <span className="visually-hidden">Next</span> </button>
        </div>
        {/* <div className="slider-info">
          <div id="carouselExampleCaptions1" className="carousel slide" data-bs-ride="carousel1">
            <div className="carousel-indicators">
              <button type="button" data-bs-target="#carouselExampleCaptions1" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExampleCaptions1" data-bs-slide-to="1" aria-label="Slide 2"></button>
            </div>
          </div>
        </div> */}
        <div className="overBox">
          <h2>EMPOWERING MINDS,<br /> SHAPING FUTURE</h2>
          <p>Smart Learning for smart <span>FUTURE</span></p>
        </div>
      </div>
    </>
  )
}

export default HomeSlider
